import React from 'react';
import OLYWebPageComponent from '../components/OLYWebPageComponent';
import { translate } from 'react-i18next';
import { LinearProgress } from 'material-ui';
import { Grid, Typography } from 'material-ui';
import { withStyles } from 'material-ui';
import { getCMSWidgetComponent, getPreviewConfiguration, setCMSConfiguration, setColorTheming } from './cmsLib';
import PopUpDialog from './PopUpDialog';
import SelectNative from '../ui/SelectNative';
import SearchHeader from '../cms/headers/SearchHeader';
import { logout } from '../components/Login/loginService';

const styles = theme => ({
    tableTitle: {
        color: theme.palette.primary.main,
        fontSize: 24,
        fontWeight: 300
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: '#3155A1',
    }
});
class Home extends OLYWebPageComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            APIcalled: false,
            dialogOpen: false,
            accountSelection: 'default',
            language: 'es',
            LangId: 'es',
            settingId: 0,
        };
        this.pageName = 'HOME';
        this.pageTitle = 'Preview CMS Content';
        let scope = this;
        //hack to use querystrings as well
        window.location.changed = function (e) { };
        (function () //create a scope so 'location' is not global
        {
            var location = window.location.href;
            setInterval(function () {
                if (location != window.location.href) {
                    location = window.location.href;
                    window.location.changed(location);
                }
            }, 1000);
        })();
        window.location.changed = function (e) {
            let queryobj = scope.__getQueryStringAsObj(e);
            scope.onQueryStringChange(queryobj);
        };
    }

    onQueryStringChange = query => {
        if (!this.state.loading) {
            let state = this.state;
            let changed = false;
            if (query && query.language) {
                changed = true;
                state.language = query.language;
            }
            if (query && query.account) {
                changed = true;
                state.accountSelection = query.account;
            }
            if (query && query.LangId) {
                changed = true;
                state.LangId = query.LangId;
            }
            if (query && query.settingId) {
                changed = true;
                state.settingId = query.settingId;
            }
            if (changed) {
                this.setState(state, () => {
                    this.loadConfiguration();
                });
            }
        }
    }

    componentDidMount = () => {
        logout();
        let scope = this;
        setTimeout(() => {
            let queryobj = scope.__getQueryStringAsObj(window.location.href.toString());
            scope.onQueryStringChange(queryobj);
        }, 1000);
    }

    loadConfiguration = async () => {
        this.setState({
            loading: true,
            APIcalled: true,
        });
        let scope = this;

        try {
            const cmsconf = await getPreviewConfiguration(
                this.state.accountSelection, this.state.LangId, this.state.settingId);
            setCMSConfiguration(cmsconf, this.state.LangId);
            setTimeout(() => {
                setColorTheming(cmsconf);
                scope.setState({ loading: false });
            }, 1000);
        } catch (error) {
            alert(error.message);
            scope.setState({ loading: false });
        }
    }

    handleCloseDialog = value => {
        //si tengo value el usuario apreto confirmar
        this.setState({ dialogOpen: false });
    };

    handleOpenDialog = value => {
        //si tengo value el usuario apreto confirmar
        this.setState({ dialogOpen: true });
    };

    render() {
        const { t } = this.props;
        return (
            <div>
                <table width='100%'>
                    <tr>
                        <td width="200">Web</td>
                        <td width="200">Lenguaje</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>
                            <SelectNative
                                labelProp="name" codeProp="name"
                                selection={this.state.accountSelection}
                                promptText="Select web to simulate"
                                onChange={val => {
                                    localStorage.setItem('x-olympia-client', val);
                                    this.setState({ accountSelection: val }, () => {
                                        this.loadConfiguration();
                                    });
                                }}
                                options={[
                                    { name: 'default' },
                                    { name: 'B2BWebDawson' },
                                    { name: 'B2BWebOlympia' },
                                    { name: 'B2BWebEroski' }
                                ]}>
                            </SelectNative>
                        </td>
                        <td>
                            <SelectNative
                                labelProp="name" codeProp="id"
                                selection={this.state.LangId}
                                promptText="Select lang to simulate"
                                onChange={val => {
                                    localStorage.setItem('x-olympia-client', val);
                                    this.setState({ language: val, LangId: val }, () => {
                                        this.loadConfiguration();
                                    });
                                }}
                                options={[{
                                    id: 'de',
                                    name: 'Alemán',
                                },
                                {
                                    id: 'es',
                                    name: 'Español',
                                },
                                {
                                    id: 'fr',
                                    name: 'Francés',
                                },
                                {
                                    id: 'en',
                                    name: 'Inglés',
                                },
                                {
                                    id: 'it',
                                    name: 'Italiano',
                                },
                                {
                                    id: 'pt',
                                    name: 'Portugués',
                                },
                                {
                                    id: 'ru',
                                    name: 'Ruso',
                                }
                                ]}>
                            </SelectNative>
                        </td>
                    </tr>
                </table>
                <div className="cmsHome cmsPreview">
                    {
                        this.state.loading || !this.state.APIcalled ?
                            <LinearProgress /> :
                            <div className="cmsContainer">
                                <div>Preview</div>
                                <div className="cmsHeader" style={{ backgroundColor: 'var(--primary-color)' }}>
                                    <SearchHeader isDisabled={true} />
                                </div>
                                <Typography>
                                <strong style={{ paddingLeft: 8 }}>{t(this.pageTitle)}</strong>
                                </Typography>
                                <Grid container className="gridTop" justify="center">
                                    <Grid item xs={4}>
                                        {getCMSWidgetComponent(2)}
                                    </Grid>
                                    <Grid item xs={8}>
                                        {getCMSWidgetComponent(3)}
                                    </Grid>
                                </Grid>
                                <Grid container className="gridCenter cmsSmallHeight" justify="center">
                                    <Grid item xs>
                                        {getCMSWidgetComponent(4, { slidesToShow: 3, slidesToScroll: 3 }, 'cmsHomeCenter')}
                                    </Grid>
                                </Grid>
                                <Grid container className="gridBottom" justify="center">
                                    <Grid item xs={6}>
                                        {getCMSWidgetComponent(5)}
                                    </Grid>
                                    <Grid item xs={6}>
                                        {getCMSWidgetComponent(6)}
                                    </Grid>
                                </Grid>
                                <PopUpDialog
                                    open={this.state.dialogOpen}
                                    onOpen={this.handleOpenDialog}
                                    onClose={this.handleCloseDialog}
                                />
                            </div>
                    }
                </div>
            </div >
        );
    }
}

export default translate('translations')(withStyles(styles)(Home));


// WEBPACK FOOTER //
// ./src/cms/Preview.js